import { Text, TextProps } from "@chakra-ui/react";
import { useMemo } from "react";

import { parseHighlightedText } from "../../utils";

export interface HighlightedTextProperties extends TextProps {
  children?: string;
}

export const HighlightedText = ({ children, ...rest }: HighlightedTextProperties): React.ReactElement => {
  const parts = useMemo(() => {
    return children == null ? [] : parseHighlightedText(children);
  }, [children]);

  return (
    <Text {...rest}>
      {parts.map((part, index) => (
        <Text as="span" fontWeight={part.highlighted ? "black" : undefined} key={index}>
          {part.text}
        </Text>
      ))}
    </Text>
  );
};
